import actionConsts from '../../constants/actions';

const orgChartData = (state = [], action = {}) => {
    switch (action.type) {
        case actionConsts.RECEIVE_INIT_DATA:
            return action.payload.orgActors ? action.payload.orgActors : {};
        default:
            return state;
    }
};

export default orgChartData;


// WEBPACK FOOTER //
// /src/reducers/uiState/orgChart.js